import { FC } from 'react';
import PairedProgressBar from 'src/components/0100_paired_progress_bar';

interface IProps {
  skillCategoriesStatistics?: { aberrant: number; total: number } | null;
}

const DystopiaRisingSkillCategoriesStatistics: FC<IProps> = ({
  skillCategoriesStatistics,
}) => {
  const aberrant = skillCategoriesStatistics?.aberrant ?? 0;
  const total = skillCategoriesStatistics?.total ?? 0;

  return (
    <div className="flex justify-center">
      <div className="border rounded border-juno-gray-700 w-full max-w-[360px] gray-box">
        <div className="flex items-end justify-between p-4 pb-2">
          <div className="uppercase text-sm text-juno-gray-200">
            Aberrant Population
          </div>
          <div>
            <span className="text-2xl text-juno-cyan-200 brightness-150 font-bold text-shadow">
              {aberrant}
            </span>
            /<span className="text-juno-gray-200">{total}</span>
          </div>
        </div>
        <PairedProgressBar
          baseline={skillCategoriesStatistics?.aberrant}
          total={skillCategoriesStatistics?.total}
          classNames={{
            baseline: 'cyan-box brightness-150',
            total: 'white-box opacity-25',
          }}
        />
      </div>
    </div>
  );
};

export default DystopiaRisingSkillCategoriesStatistics;
